import React, { FC } from 'react';

import { Flex } from '@chakra-ui/react';

import { ScansTypesViewProps } from './ScansTypes.props';

const ScansTypesView: FC<ScansTypesViewProps> = (props) => (
  <Flex>ScansTypes</Flex>
);

export default ScansTypesView;
